import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { firebase, storage } from 'core';
import { Api } from 'lib';
import { store } from 'store';

function GgLogin({ CustomButton, followUpDetails, redirectUrl }) {
  // Gets access_token
  const initiateLogin = useGoogleLogin({
    onSuccess: login,
    onError: login
  });

  async function login(e) {
    // Get user info with access_token
    const googleInfo = await axios.get(
      `https://www.googleapis.com/oauth2/v1/userinfo?alt=json&access_token=${e.access_token}`
    );
    if (googleInfo.status !== 200) return;
    const { email, name, id, picture } = googleInfo.data;

    const res = await Api.post('/users/ggLogin', { email, id, name, photo: picture }, 'navigator');
    if (!res) return;

    await storage.setItem('token', res.token);

    firebase.logEvent(res.created ? 'sign_up' : 'login', { method: 'google' });

    if (followUpDetails && Object.keys(followUpDetails).length > 0) {
      const { actionType, otherUser, action } = followUpDetails;
      const isShoutout = actionType === 'requestShoutout' || actionType === 'sendShoutout';

      store.dispatch({
        type: 'SET_USER',
        payload: {
          ...res.user,
          atheleteIdToSubscribe: actionType === 'subscribe' ? otherUser?._id : null,
          athleteUsernameToFollow: actionType === 'follow' ? otherUser?.username : null,
          atheleteUsernameToFace2Face: actionType === 'face2face' ? otherUser?.username : null,
          atheleteUsernameToAdPlayaz: actionType === 'adPlayaz' ? otherUser?.username : null,
          athleteUsernameToShoutout: isShoutout ? otherUser?.username : null,
          fromAtheleteUsername: actionType === 'fromUser' ? otherUser?.username : null,
          followUpAction: actionType
        }
      });

      if (action && typeof action === 'function') {
        await action();
      }
    } else {
      // Strip leading slash from redirectUrl since User.js adds one
      const navigateTo = redirectUrl
        ? decodeURIComponent(redirectUrl).replace(/^\//, '')
        : res.user.admin || process.env.REACT_APP_DEFAULT_TEAM_REDIRECT === 'false' ? null : `profile/${process.env.REACT_APP_DEFAULT_TEAM_USERNAME || 'fctokyo'}`;

      store.dispatch({
        type: 'SET_USER',
        payload: { ...res.user, navigateTo }
      });
    }
  }

  return <CustomButton onClick={initiateLogin} />;
}

export default GgLogin;
